// extracted by mini-css-extract-plugin
export default {"primaryBanner":"PrimaryBanner_primaryBanner__+TYhB","primaryBannerImage":"PrimaryBanner_primaryBannerImage__xxpuA","textContainer":"PrimaryBanner_textContainer__44wpP"};